<template lang="html">
  <card class="content-card">
    <template slot="header">
      <card-controls :back="false">
        <span slot="actions">
          <n-button
            type="primary"
            simple=""
            @click.native="createNewRecord()">
            <i class="fas fa-plus-circle" />
            Registrar Monitoreo
          </n-button>
          <n-button
            v-if="!components.globalFilter"
            type="primary"
            simple=""
            @click.native="components.globalFilter = true">
            <i class="fal fa-filter"/>
          </n-button>
          <n-button
            v-if="components.globalFilter"
            type="danger"
            simple=""
            @click.native="handleCloseFilter()">
            <i class="fal fa-filter"/>
          </n-button>
          <n-button
            type="primary"
            simple=""
            @click.native="goToDiagram">
            <i class="fal fa-project-diagram"/>
          </n-button>
        </span>
      </card-controls>

      <h4 class="card-title"><b>Monitoreo de Plagas y Enfermedades</b></h4>
    </template>

    <global-filter
      v-if="components.globalFilter"
      :records="records"
      :sectors="sectors"
      @close="handleCloseFilter"
      @applyFilter="applyFilter"/>

    <div v-loading="loader">
      <record-groups
        v-if="!loader"
        :sectors="sectors"
        :records="records"
        :show-all-tab="showAllTab"/>
    </div>

  </card>
</template>

<script>
import RecordGroups from "./Components/PlagueMonitoringGroups"
import GlobalFilter from "./Components/GlobalFilter"
export default {
    components: {
        RecordGroups,
        GlobalFilter
    },
    data() {
        return {
            loader: true,
            sectors: [],
            records: [],
            components: {
                globalFilter: false
            },
            farm_id: "",
            showAllTab: ""
        }
    },
    created() {
        this.farm_id = this.$store.getters["Farms/GET_FARM"]._id.$oid
        this.getSectors()
    },
    methods: {
        createNewRecord() {
            this.$router.push({
                name: "tasklist-start-process",
                params: {
                    id: "plague-monitoring"
                }
            })
        },
        getSectors() {
            let vm = this
            this.loader = true

            this.Services.Sectors.getSectors(this.farm_id)
                .then(response => {
                    vm.sectors = response.data
                })
                .catch(error => {
                    console.log(error)
                })
                .finally(() => {
                    vm.getRecords()
                })
        },
        getRecords(filter) {
            let vm = this
            this.Services.PlagueMonitorings.getPlagueMonitorings(
                this.farm_id,
                filter
            )
                .then(response => {
                    vm.records = response.data
                    vm.showAllTab = filter != undefined ? true : false
                })
                .catch(error => {
                    console.log(error)
                })
                .finally(() => {
                    vm.loader = false
                })
        },
        handleCloseFilter() {
            this.components.globalFilter = false
            this.getRecords()
        },
        applyFilter(query) {
            this.loader = true
            this.getRecords(query)
        },
        goToDiagram() {
            this.$router.push({
                name: "diagram",
                params: {
                    processKey: "plague-monitoring",
                    state: "new",
                    backTarget: "plague-monitorings"
                }
            })
        }
    }
}
</script>

<style lang="css" scoped>
</style>
